import React from 'react'
import { useTranslation } from 'react-i18next'

import { CrossCircledIcon } from '../../../../assets/icons/CrossCircledIcon'
import { Filter } from '../../../../assets/icons/Filter'

import { ActiveTagContainer, TagText, DeleteFilterButt } from './ActiveFilter.styled'

interface ActiveFilterProps {
  filterName: string
  selectedOptions: string[]
  onRemove: () => void
}

export const ActiveFilter = ({ filterName, selectedOptions, onRemove }: ActiveFilterProps) => {
  const { t } = useTranslation('botMitigation')

  const optionsString = () => {
    const optionsLength = selectedOptions.length
    if (optionsLength === 1) {
      return selectedOptions[0]
    } else if (optionsLength === 2) {
      return `${selectedOptions[0]} or ${selectedOptions[1]}`
    } else {
      return `${selectedOptions[0]}, ${selectedOptions[1]} or ${optionsLength - 2} more`
    }
  }
  return (
    <ActiveTagContainer>
      <Filter width={'12px'} height={'12px'} />
      <TagText>{`${t(`advancedFilters.${filterName}`)}: ${optionsString()}`}</TagText>
      <DeleteFilterButt onClick={onRemove}>
        <CrossCircledIcon width={'14px'} height={'14px'} />
      </DeleteFilterButt>
    </ActiveTagContainer>
  )
}
